export default {
    sort: 'Sort',
    filter: 'Filter',
    detail_search: 'Search in detail',
    detail: 'Detail',
    price_missmatch: 'Price from must be less than price to',
    fields: {
        term: {
            label: 'Search term',
            placeholder: 'Enter the search term',
        },
        include_description: {
            label: 'Include description in the search',
        },
        city: {
            label: 'City',
            placeholder: 'Select',
        },
        currency: {
            label: 'Currency',
        },
        category: {
            label: 'Category',
            placeholder: 'Select',
        },
        subcategory: {
            label: 'Sub category',
            placeholder: 'Select',
        },
        price_from: {
            label: 'Price from',
            placeholder: 'Enter',
        },
        price_to: {
            label: 'Price to',
            placeholder: 'Enter',
        },
    },
    sort_options: {
        sort: 'Sort',
        createdAt_ASC: 'Date ascending',
        createdAt_DESC: 'Date descending',
        distance_ASC: 'Distance',
        priceRSD_ASC: 'Price ascending',
        priceRSD_DESC: 'Price descending',
        averageRating_ASC: 'Rating ascending',
        averageRating_DESC: 'Rating descending',
    },
}
